import React from "react";
import Alert from "@mui/material/Alert";

const getSeverity = (type) => {
  let severity = type;
  if (type === "notice") {
    severity = "info";
  } else if (!["error", "warning", "info", "success"].includes(severity)) {
    severity = "warning";
  }

  return severity;
};

const PlatformAlerts = () => {
  const domContainer = document.getElementById("icer-spa");
  if (domContainer) {
    const alerts = JSON.parse(domContainer.dataset.alerts);
    if (alerts && alerts.length) {
      return (
        <>
          {alerts.map(([type, message], i) => (
            <Alert key={i} severity={getSeverity(type)} sx={{ fontSize: 16 }}>
              {" "}
              {message}{" "}
            </Alert>
          ))}
        </>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default PlatformAlerts;
